import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { callAPI, IRoleMain, IsSmallScreen, MasterPages, Method } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";

interface PaymentOutProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: any;
}
const PaymentOut: React.FC<PaymentOutProps> = ({
  control, errors, register, id, reset, departmentId, setValue, }) => {
  const isMobile=IsSmallScreen()
  useEffect(
    () => () => {
      reset();
    },
    [id, reset]
  );

  const [showExtraFields, setShowExtraFields] = useState(false);
  const genId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);
  const [paymentRows, setPaymentRows] = useState(() => [{ id: genId(), paymentType: '', amount: '' }]);
  
  const handleAddRow = () => setPaymentRows(prev => [...prev, { id: genId(), paymentType: '', amount: '' }]);
  const handleRemoveRow = (idToRemove:any) => setPaymentRows(prev => prev.filter(r => r.id !== idToRemove));
 
  return (
    <>
          <Grid  style={{paddingLeft:5,paddingRight:20,position:'relative',margin:0,marginTop:'3rem'}} container spacing={2}>
            <Grid item xs={12} sm={6}>
               <WSSelectField
                rules={{ required: true }}
                {...register("party")}
                id="party"
                control={control}
                isMobile={isMobile}
                label="Party"
                name="party"
              />
            </Grid>
             <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Bill No"}
                {...register("billNo")}
                id="billNo"
                name="billNo"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
      {!showExtraFields ? (
        <>
          <WSSelectField
            label="Payment Type"
            rules={{ required: true }}
            {...register("paymentType")}
            id={"paymentType"}
            control={control}
          />
          <Button
            variant="text"
            size="small"
            sx={{ textTransform: "none", p: 0, mt: 1 }}
            onClick={() => setShowExtraFields(true)}
          >
            + Add Payment Details
          </Button>
        </>
      ) : (
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={2}>
          {paymentRows.map((row, index) => (
  <React.Fragment key={row.id}>
    <Grid item xs={12} sm={4}>
      <WSSelectField
        label="Payment Type"
        {...register(`paymentRows.${index}.paymentType`)}
        id={`paymentType-${row.id}`}
        control={control}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSTextField
        label="Amount"
        {...register(`paymentRows.${index}.amount`)}
        id={`amount-${row.id}`}
        control={control}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSIcons.DeleteIcon onClick={() => handleRemoveRow(row.id)} sx={{ cursor: 'pointer' }} />
    </Grid>
  </React.Fragment>
))}

            <Grid item xs={12}>
              <Button
                variant="text"
                size="small"
                sx={{ textTransform: "none", p: 0, mt: 1 }}
                onClick={handleAddRow}
              >
                + Add Payment Type
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}
    </Grid>
      
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="billDate"
                name="billDate"
                label={"Bill Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
              <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Paid"}
                {...register("paid")}
                id="paid"
                name="paid"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
           <Grid item xs={12} >
            <WSTextAreaField
              label={"Description"}
              id={"description"}
              name={"description"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
          </Grid>
        <Grid item xs={12}>
            <WSImageUpload
              control={control}
              id="image"
              name="image"
              label=""
              rules={{ required: false }}
            />
          </Grid>
          </Grid>
          </>

  );
};
export default PaymentOut;
